import $ from 'jquery';
import Swiper from 'swiper/bundle';
import 'swiper/swiper-bundle.css';

// const slider1 = new Swiper('.c-slider01', {
//   loop: true,
//   pagination: {
//     el: '.swiper-pagination',
//   },
//   navigation: {
//     nextEl: '.swiper-button-next',
//     prevEl: '.swiper-button-prev',
//   },
// });

$('.js-slide1').each(function () {
	var thumbs = new Swiper('.js-slide1-thumbs', {
		loop: false,
		spaceBetween: 4,
		slidesPerView: 3.85,
		freeMode: true,
		watchSlidesProgress: true,
		navigation: {
			nextEl: '.js-slide1 .js-slide1-thumbs .swiper-button-next',
			prevEl: '.js-slide1 .js-slide1-thumbs .swiper-button-prev',
		},
		breakpoints: {
			751: {
				slidesPerView: 6,
			},
		},
	});

	var main = new Swiper('.js-slide1 .js-slide1-main .swiper', {
		loop: true,
		spaceBetween: 10,
		effect: 'fade',
		navigation: {
			nextEl: '.js-slide1 .js-slide1-main .c-slide1__main__btn.next',
			prevEl: '.js-slide1 .js-slide1-main .c-slide1__main__btn.prev',
		},
		thumbs: {
			swiper: thumbs,
		},
		pagination: {
			el: '.js-slide1 .js-slide1-main .swiper-pagination',
			type: 'fraction',
		},
	});
});

function initSlide2() {
	let list2 = $('.js-slide2');
	if (list2.length) {
		list2.each(function () {
			let _this = $(this);

			new Swiper(_this[0], {
				loop: false,
				slidesPerView: 1.53,
				paginationClickable: true,
				spaceBetween: 14,
			});
		});
	}
}

function destroySlide2() {
	let slide2 = $('.js-slide2');
	if (slide2.length) {
		slide2.each(function () {
			let _this = $(this);
			if ($(_this[0]).hasClass('swiper-initialized')) {
				_this[0].swiper.destroy();
			}
		});
	}
}

function initSlide3() {
	let list2 = $('.js-slide3');
	if (list2.length) {
		list2.each(function () {
			let _this = $(this);

			new Swiper(_this[0], {
				loop: false,
				slidesPerView: 1.53,
				paginationClickable: true,
				spaceBetween: 14,
			});
		});
	}
}

function destroySlide3() {
	let slide3 = $('.js-slide3');
	if (slide3.length) {
		slide3.each(function () {
			let _this = $(this);
			if ($(_this[0]).hasClass('swiper-initialized')) {
				_this[0].swiper.destroy();
			}
		});
	}
}

function checkScreenSize() {
	if ($(window).outerWidth() <= 750) {
		initSlide2();
		initSlide3();
	} else {
		destroySlide2();
		destroySlide3();
	}
}

$(window).on('load resize', function () {
	checkScreenSize();
});
